import { render, staticRenderFns } from "./confiSceneMain.vue?vue&type=template&id=2c9681de&"
import script from "./confiSceneMain.vue?vue&type=script&lang=js&"
export * from "./confiSceneMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports